import { rawAxios as axios } from "./axios";
import { api } from "./axios.config";

// const API_URL = api.manageApiUrl;

const API_URL = api.manageApiUrl;

const GET_RESOURCES = "/resources";

export function getResources(limit, searchQuery = "", resourceType = "", offset = "") {
	let QUERY = `?limit=${limit}&offset=${offset}`;
	if (searchQuery !== "") QUERY += `&search_query=${searchQuery}`;
	if (resourceType !== "") QUERY += `&resource_type_filter=${resourceType}`;
	return axios.get(API_URL + GET_RESOURCES + QUERY);
}

export function getResourcesDetails(id) {
	let QUERY = `/${id}`;
	return axios.get(API_URL + GET_RESOURCES + QUERY);
}
